export const Client = {
    Path: {
        Root: "/",
        Account: {
            Login: "/login",
            Logout: "/logout",
            ForgotPassword: "/forgotpassword",
            ResetPassword: "/resetpassword",
            CreatePassword: "/createpassword",
        },
        Dashboard: "/:propertyId",
        Choices: "/choices/:propertyId",
        ChoicesArea: "/choicesarea/:propertyId/:areaId",
        ChoicesAreaProductGroup: "/choicesareaproductgroup/:propertyId/:areaId/:productGroupId",
        Documents: "/documents/:propertyId",
        Inspection: "/inspection/:propertyId",
        Progress: "/progress/:propertyId",
        Property: "/property/:propertyId",
        Snag: "/snag/:propertyId/:snagId",
        Snags: "/snags/:propertyId",
        Payment: "/payment/:propertyId",
        Signatures: "/signatures/:propertyId",
        SignatureForm: "/reservation/:propertyId/sign/:reservationId",
        SignatureRequest: "/signatures/:propertyId/:reservationId/:signatureToken",
        SuperAdmin: "/superadmin",
    },
};

export const Server = {
    Api: {
        Account: {
            Login: "./api/account/login",
            Logout: "./api/account/logout",
            ChangePassword: "./api/account/changepassword",
            ForgotPassword: "./api/account/forgotpassword",
        },
        Dashboard: {
            Get: "./api/dashboard/get",
            GetByPropertyId: "./api/dashboard/getbypropertyid",
            GetChoices: "./api/dashboard/getchoices",
            GetChoicesAndRelated: "./api/dashboard/getchoicesandrelated",
            GetDocuments: "./api/dashboard/getdocuments",
            GetDocument: "./api/dashboard/getdocument",
            GetDevelopmentDocuments: "./api/dashboard/getdevelopmentdocuments",
            GetDevelopmentDocument: "./api/dashboard/getdevelopmentdocument",
            GetProgress: "./api/dashboard/getprogress",
            GetProperty: "./api/dashboard/getproperty",
            GetSnags: "./api/dashboard/getsnags",
            GetInspection: "./api/dashboard/getinspection",
            GetInspectionDocuments: "./api/dashboard/getinspectiondocuments",
            GetPropertyDrawingDocuments: "./api/dashboard/getdrawingdocuments",
            GetPropertyDrawingDocument: "./api/dashboard/getdrawingdocument",
            GetUserSignatureRole: "/api/dashboard/GetUserSignatureRole",
        },
        Snags: {
            GetViewById: "./api/snags/GetViewByid",
            GetSnagRelated: "./api/snags/getrelated",
            Upsert: "./api/snags/upsert",
        },
        Choices: {
            GetChoicesArea: "./api/choices/getchoicesarea",
            GetChoicesAreaAndRelated: "./api/choices/getchoicesareaandrelated",
            AddToOrder: "./api/choices/addtoorder",
            GetChoicesSummary: "./api/choices/getchoicessummary",
            GetIsChoicesLocked: "./api/choices/getischoiceslocked",
        },
        Image: {
            GetCompanyImage: "./api/image/getcompanyimage",
            GetBlob: "/api/image/getblob",
            Upload: "./api/image/upload",
        },
        ReservationType1: {
            GetReservationType1AndRelated: "./api/reservationtype1/getreservationtype1andrelated",
            UpsertReservationType1Financial: "./api/reservationtype1/upsertreservationtype1financial",
            EmailSignedReservationCopy: "./api/reservationtype1/emailsignedreservationcopy",
            GetSignatureStatus: "./api/reservationtype1/getsignaturestatus",
            UpsertSignatureStatus: "./api/reservationtype1/upsertsignaturestatus",
            PublishSignatureRequest: "./api/reservationtype1/publishsignaturerequest",
            MarkSignatureComplete: "./api/reservationtype1/marksignaturecomplete",
            GetActiveSignatureRequests: "./api/reservationtype1/getactivesignaturerequests",
        },
        Signature: {
            GenerateSignatureRequest: "./api/signature/generatesignaturerequest",
            MarkSignatureComplete: "./api/signature/marksignaturecomplete",
            GetSignedReservationData: "./api/signature/getsignedreservationdata",
            AllowRetroactiveSignature: "./api/signature/allowretroactivesignature",
            ValidateSignatureToken: "./api/signature/validatesignaturetoken",
        },
        SuperAdmin: {
            GetCustomersWithPortalAccess: "./api/superadmin/getcustomerswithportalaccess",
            GetCompanies: "./api/superadmin/getcompanies",
            GetPropertiesByCompany: "./api/superadmin/getpropertiesbycompany",
        },

        // Likely redundant and can be removed.
        Admin: {
            ResetFailedLoginAttemptsCount: "",
        },
    },
};
